import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { languageToCountries } from './countries/language-to-countries';
import { languageToCurrencies } from './currencies/language-to-currencies';

export function NestechHttpLoaderFactory(
  getTranslationFn: (language: string) => Observable<TranslationObject>,
): NestechTranslateHttpLoader {
  return new NestechTranslateHttpLoader(getTranslationFn);
}

export class NestechTranslateHttpLoader implements TranslateLoader {
  constructor(private getTranslationFn: (language: string) => Observable<TranslationObject>) {}

  getTranslation(language: string): Observable<TranslationObject> {
    return this.getTranslationFn(language).pipe(
      catchError(error => {
        console.error(`Failed to load translations. Falling back to empty object.`, error);
        return of({});
      }),
      map(translations => {
        const countries = languageToCountries[language];
        const currencies = languageToCurrencies[language];
        return {
          countries,
          currencies,
          ...translations,
        };
      }),
    );
  }
}
